var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.classes,on:{"click":_vm.clicked}},[_c('div',{staticClass:"icons"},[_c('i',{class:_vm.icon1Full}),_c('i',{class:_vm.icon2Full})])])
}
var staticRenderFns = []

export { render, staticRenderFns }